/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootAliases {
  ALTERAR_SENHA_FRAGMENT = 'alterar-senha-fragment',
  ALTERAR_SENHA_ROUTE = 'alterar-senha-route',
  ALTERAR_SENHA_USERNAME_FRAGMENT = 'alterar-senha-username-fragment',
  ALTERAR_SENHA_USERNAME_ROUTE = 'alterar-senha-username-route',
  CONF_USUARIO_NOVA_SENHA_FRAGMENT = 'conf-usuario-nova-senha-fragment',
  CONF_USUARIO_NOVA_SENHA_ROUTE = 'conf-usuario-nova-senha-route',
  CONFIRMAR_USUARIO_FALHA_FRAGMENT = 'confirmar-usuario-falha-fragment',
  CONFIRMAR_USUARIO_FALHA_ROUTE = 'confirmar-usuario-falha-route',
  CONFIRMAR_USUARIO_FRAGMENT = 'confirmar-usuario-fragment',
  CONFIRMAR_USUARIO_ROUTE = 'confirmar-usuario-route',
  FORGOT_PASSWORD_FRAGMENT = 'forgot-password-fragment',
  FORGOT_PASSWORD_ROUTE = 'forgot-password-route',
  HPMS_MANAGER_DIALOG_0 = 'hpms-manager-dialog-0',
  INACTIVITY_FRAGMENT = 'inactivity-fragment',
  INACTIVITY_ROUTE = 'inactivity-route',
  LAYOUT_ROOT = 'layout-root',
  LOGIN_FRAGMENT = 'login-fragment',
  LOGIN_ROUTE = 'login-route',
  NEW_PASSWORD_FRAGMENT = 'new-password-fragment',
  NEW_PASSWORD_ROUTE = 'new-password-route',
  REDIRECT_FRAGMENT = 'redirect-fragment',
  REDIRECT_ROUTE = 'redirect-route',
  STIPULATOR_FRAGMENT = 'stipulator-fragment',
  STIPULATOR_ROUTE = 'stipulator-route',
}
export { RootAliases };
